import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography
} from '@mui/material';
import {styles, ticketSelectorColumns as columns} from '@invoice-system';
import {table} from '@components/common/styles';
import {t} from 'ttag';
import {Close} from '@mui/icons-material';
import {DataGrid, GridColDef} from '@mui/x-data-grid';
import {useNavigate} from 'react-router-dom';
import {useGetInvoicesQuery} from '../../../../store/apis/ccs';
import RTKQueryFeedback from '@components/common/RTKQueryFeedback';

interface TicketSelectorDialogProps {
  invoiceNumber: string;
  onClose: () => void;
}

export const TicketSelectorDialog = ({invoiceNumber, onClose}: TicketSelectorDialogProps) => {
  const navigate = useNavigate();
  const {data, isFetching, error} = useGetInvoicesQuery({documentId: invoiceNumber});

  if (isFetching) {
    return <RTKQueryFeedback isLoading={true}/>
  }

  const handleTicketSelect = (value: string) => {
    const ticketId = value.replace(/^(\d{3})/, '$1-');
    sessionStorage.setItem('searchInvoice', invoiceNumber);
    navigate(`/invoice/${ticketId}`);
  }

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth={'lg'}>
      <DialogTitle>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'start'}>
          <Box display={'flex'} flexDirection={'column'}>
            <Typography sx={styles.subtitle}>{t`Select Ticket with Invoice` + ` ${invoiceNumber}`}</Typography>
            <Typography
              variant={'body2'}
              color={'text.secondary'}
            >{t`Select ticket with the invoice number you searched for.`}</Typography>
          </Box>
          <IconButton onClick={onClose} size={'small'}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider/>
      <DialogContent>
        <DataGrid
          rows={data || []}
          columns={columns((ticketId) => handleTicketSelect(ticketId)) as GridColDef[]}
          disableColumnMenu
          sx={table}
          getRowId={(row => row.ticket + row.sequence)}
          hideFooter
          autoHeight
          slots={{
            noRowsOverlay: () => <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'} width={'100%'}>
              <Typography variant={'body2'} color={'secondary.main'} align={'center'}>{t`No tickets found`}</Typography>
            </Box>
          }}
          loading={isFetching}
          disableRowSelectionOnClick
        />
      </DialogContent>
      <Divider/>
      <DialogActions sx={{justifyContent: 'space-between', px: 3, py: 1.5}}>
        <Button variant={'outlined'} onClick={onClose}>{t`Cancel`}</Button>
      </DialogActions>
      <RTKQueryFeedback error={error} snackbarOnErrorOptions={{variant: 'error', preventDuplicate: true}}/>
    </Dialog>
  )
}
